var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import produce from 'immer';
import { types } from '../actions/websocket';
var initialState = {
    connected: false,
    error: false,
    data: {},
};
var socketOpen = function () { return ({
    connected: true,
    error: false,
    data: {},
}); };
var socketError = function () { return ({
    connected: false,
    error: true,
    data: {},
}); };
var socketClose = function () { return ({
    connected: false,
    error: false,
    data: {},
}); };
var subscribeToProcess = function (state, payload) {
    return produce(state, function (draftState) {
        var processes = payload.processes;
        draftState.data = {
            subscriptions: __spreadArrays((state.data.subscriptions || []), processes),
        };
    });
};
var unsubscribeToProcess = function (state, payload) {
    return produce(state, function (drafState) {
        var processes = payload.processes;
        drafState.data = {
            subscriptions: (state.data.subscriptions || []).filter(function (pid) { return !processes.find(function (p) { return p === pid; }); }),
        };
    });
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case types.SOCKET_OPEN:
            return socketOpen();
        case types.SOCKET_ERROR:
            return socketError();
        case types.SOCKET_CLOSE:
            return socketClose();
        case types.SUBSCRIBE_TO_PROCESS:
            return subscribeToProcess(state, payload);
        case types.UNSUBSCRIBE_TO_PROCESS:
            return unsubscribeToProcess(state, payload);
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=websocket.js.map